export default {
  className: 'luckyStarRecords',
  fields: [
    'user',
    'access',
    'number',
    'revenue',
    'realTimeBalance'
  ],
  search: [
    'user',
    'access'
  ],
  action: false
}
